module.exports = __webpack_public_path__ + "img/origami_bangtao.db3ef720.jpg";